import { memo } from 'react'

import { timeFormatter } from 'utils/time-formatter'

import * as Styled from './styled'

interface IProps {
  title: string
  duration: number
}

const SoundListItemInfo: React.FC<IProps> = ({ title, duration }) => {
  return (
    <Styled.SoundInfoWrapper>
      <Styled.SoundsTitle type="h4" color="secondarySemiDark" ellipsis>
        {title}
      </Styled.SoundsTitle>
      <Styled.SoundsDuration type="p" color="secondary">
        {timeFormatter(duration)}
      </Styled.SoundsDuration>
    </Styled.SoundInfoWrapper>
  )
}

export default memo(SoundListItemInfo)
